export default __webpack_public_path__ + "static/media/microphone.795d10f1.png";